import React from 'react';
import { connect } from 'react-redux';
import Spin from '../../../components/loading';
import * as authActions from '../../../redux/auth/actions';
import { withRouter } from 'react-router-dom';

class SetNewPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      repeatPassword: '',
      successFlag: false,
      errorFlag: false,
      errorText: ''
    }
  }

  onSubmit = event => {
    let { password, repeatPassword } = this.state
    let { mobileNumber, resetPassToken } = this.props;
    event.preventDefault();
    if (password !== repeatPassword) {
      this.setState({ errorFlag: true, errorText: locales('alerts.PasswordsNotMatch') })
    }
    else {
      this.setState({ errorFlag: false }, () => {
        this.props.sendNewPassword(password, mobileNumber, resetPassToken).then(() => {
          this.setState({ successFlag: true }, () => {
            setTimeout(() => {
              this.props.history.push('/login');
            }, 3000);
          })
        })
      })
    }
  }

  render() {
    let { password, successFlag, repeatPassword, errorFlag, errorText } = this.state;
    let { loading, error, message, failed } = this.props;

    return (
      <>
        {successFlag && <div className='alert alert-success'>
          {locales('titles.passwordSuccessfullyChanged')} </div>}
        {
          error &&
          <div className="alert alert-danger" >
            {locales("messages.server.error")}
          </div>
        }
        {failed && <div className="alert alert-danger">{message}</div>}
        <Spin spinning={loading}>
          <div className='col-12 d-flex justify-content-center align-items-center flex-column'>
            <input
              value={password}
              onChange={event => this.setState({ password: event.target.value, errorFlag: false })}
              placeholder={locales("titles.enterNewPassword")}
              type="password"
              className={`${errorFlag ? 'border border-danger' : ''} form-control col-10 my-1`}
            />
            <div className='text-danger'>
              {errorFlag && errorText}
            </div>
            <input
              value={repeatPassword}
              onChange={event => this.setState({ repeatPassword: event.target.value, errorFlag: false })}
              placeholder={locales("titles.reEnterNewPassword")}
              type="password"
              className={`${errorFlag ? 'border border-danger' : ''} form-control col-10 my-1`}
            />
            <div className='text-danger'>
              {errorFlag && errorText}
            </div>
            <div className='d-flex col-12 justify-content-center align-items-center my-2'>
              <button
                disabled={repeatPassword.length < 4 || password.length < 4}
                onClick={this.onSubmit}
                className='btn btn-primary'
              >
                {locales('titles.setNewPassord')}
              </button>
            </div>
          </div>
        </Spin>
      </>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    loading: state.authReducer.setNewPasswordLoading,
    message: state.authReducer.setNewPasswordMessage,
    failed: state.authReducer.setNewPasswordFailed,
    error: state.authReducer.setNewPasswordError,
    resetPassToken: state.authReducer.checkVerificationCode,
  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    sendNewPassword: (password, mobileNumber, resetPassToken) => dispatch(authActions.sendNewPassword(password, mobileNumber, resetPassToken))
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SetNewPassword));